// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeaS1fFr {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 1rem;
}
@media (max-width: 767px) {
  .LeaS1fFr {
    padding: 1rem;
  }
}
.J2HP87iK {
  position: relative;
  background: #ffffff;
  border-radius: 0.75rem;
  max-width: min(100%, 32rem);
  width: 100%;
  padding: 3rem 1.5rem 2rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  -webkit-animation: LTjc1z3e 0.3s ease;
          animation: LTjc1z3e 0.3s ease;
}
@media (max-width: 767px) {
  .J2HP87iK {
    max-width: 90%;
    padding: 2rem 1rem;
  }
}
@-webkit-keyframes LTjc1z3e {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes LTjc1z3e {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.HvSwzAXT {
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .HvSwzAXT {
    font-size: 1.5rem;
  }
}
.fZaUwFkV {
  margin-bottom: 1.5rem;
  position: relative;
}
@media (max-width: 767px) {
  .fZaUwFkV {
    margin-bottom: 1rem;
  }
}
._969EMhxi {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  min-width: 0;
  border: 1px solid #e0e0e0;
  border-radius: 1.25rem;
  background: #ffffff;
  overflow: visible;
  z-index: 1;
  -webkit-transition: border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 3rem;
}
._969EMhxi.RcnOIgJC {
  border-radius: 1.25rem 1.25rem 0 0;
  border-bottom: 1px solid transparent;
}
@media (max-width: 767px) {
  ._969EMhxi {
    min-height: 2.5rem;
  }
}
.bKdnsQEy {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  width: 100%;
  padding: 1rem;
  padding-right: 0.25rem;
  border: none;
  outline: none;
  font-size: 1rem;
  color: #585858;
  background: transparent;
  line-height: 1.5;
  min-height: auto;
}
.bKdnsQEy::-webkit-input-placeholder {
  color: #cccccc;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.015em;
}
.bKdnsQEy::-moz-placeholder {
  color: #cccccc;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.015em;
}
.bKdnsQEy::placeholder {
  color: #cccccc;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.015em;
}
@media (max-width: 767px) {
  .bKdnsQEy {
    padding: 0.5rem;
    font-size: 0.875rem;
  }
  .bKdnsQEy::-webkit-input-placeholder {
    font-size: 0.8rem;
    letter-spacing: -0.02em;
  }
  .bKdnsQEy::-moz-placeholder {
    font-size: 0.8rem;
    letter-spacing: -0.02em;
  }
  .bKdnsQEy::placeholder {
    font-size: 0.8rem;
    letter-spacing: -0.02em;
  }
}
.Ymu4vWVF {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  padding: 1rem;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  outline: none;
  min-height: 3rem;
}
@media (max-width: 767px) {
  .Ymu4vWVF {
    padding: 0.5rem;
    min-height: 2.5rem;
  }
}
.nj9mfuGx {
  font-size: 1rem;
  color: #585858;
  font-weight: normal;
  width: 100%;
}
@media (max-width: 767px) {
  .nj9mfuGx {
    font-size: 0.875rem;
  }
}
.zwv60tv4 {
  font-size: 1rem;
  color: #cccccc;
}
@media (max-width: 767px) {
  .zwv60tv4 {
    font-size: 0.875rem;
  }
}
.TqWA51oL {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  padding: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  color: #666666;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .TqWA51oL {
    padding: 0.5rem;
  }
}
.VgvIGa05 {
  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}
.ZV5EWaOt {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
}
.zohX71bj {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.uKhqf4zw {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-top: 1px solid transparent;
  border-radius: 0 0 20px 20px;
  max-height: 12.5rem;
  overflow-y: auto;
  z-index: 10;
  margin-top: -1px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  -webkit-animation: hPWD94DU 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          animation: hPWD94DU 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transform-origin: top;
          transform-origin: top;
  overflow-x: hidden;
}
@-webkit-keyframes hPWD94DU {
  from {
    opacity: 0;
    -webkit-transform: translateY(-10px) scaleY(0.95);
            transform: translateY(-10px) scaleY(0.95);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0) scaleY(1);
            transform: translateY(0) scaleY(1);
  }
}
@keyframes hPWD94DU {
  from {
    opacity: 0;
    -webkit-transform: translateY(-10px) scaleY(0.95);
            transform: translateY(-10px) scaleY(0.95);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0) scaleY(1);
            transform: translateY(0) scaleY(1);
  }
}
.PkycylE_ {
  padding: 1rem;
  cursor: pointer;
  font-size: 1rem;
  color: #585858;
  -webkit-transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.15s ease;
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.15s ease;
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s ease;
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s ease, -webkit-transform 0.15s ease;
  -webkit-transform: translateZ(0);
          transform: translateZ(0);
}
.PkycylE_:hover {
  background: #f5f5f5;
  -webkit-transform: translateX(2px);
          transform: translateX(2px);
}
.PkycylE_:active {
  background: #e8e8e8;
  -webkit-transform: translateX(0) scale(0.98);
          transform: translateX(0) scale(0.98);
}
.PkycylE_.IaZIvCvG {
  background: rgba(24, 144, 255, 0.1);
  color: #1890ff;
  font-weight: 500;
}
@media (max-width: 767px) {
  .PkycylE_ {
    padding: 0.5rem;
    font-size: 0.875rem;
  }
}
.OvuUhSxr {
  padding: 1rem;
  font-size: 0.875rem;
  color: #666666;
  text-align: center;
}
@media (max-width: 767px) {
  .OvuUhSxr {
    padding: 0.5rem;
    font-size: 0.75rem;
  }
}
.Ipquc5gU {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  padding: 1rem;
  background: #626cda;
  border: none;
  border-radius: 1.25rem;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  width: 100%;
  margin-top: 1rem;
}
.Ipquc5gU:hover {
  background: #3945d0;
}
.Ipquc5gU:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .Ipquc5gU {
    font-size: 0.875rem;
    padding: 0.5rem;
  }
}
.OvPYSVbM {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  bottom: -60px;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.OvPYSVbM:hover {
  background: #f5f5f5;
  border-color: #666666;
}
.OvPYSVbM:active {
  -webkit-transform: translateX(-50%) scale(0.95);
          transform: translateX(-50%) scale(0.95);
}
.L4jaH609 {
  width: 2.5rem;
  height: 2.5rem;
  -o-object-fit: contain;
     object-fit: contain;
}
@media (max-width: 767px) {
  .L4jaH609 {
    width: 2.5rem;
    height: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerSelectModal/ServerSelectModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECkBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDlBA,aAAA;AAAF;ACTE;EAAA;IDYE,aAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;EACA,qCAAA;UAAA,6BAAA;AAAF;ACxBE;EAAA;ID2BE,cAAA;IACA,kBAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AARA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AChDE;EAAA;IDoDE,iBAAA;EAAF;AACF;AAGA;EACE,qBAAA;EACA,kBAAA;AADF;ACzDE;EAAA;ID6DE,mBAAA;EAAF;AACF;AAGA;EACE,kBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mEAAA;EAAA,2DAAA;EACA,gBAAA;AADF;AAIE;EACE,kCAAA;EACA,oCAAA;AAFJ;AC/EE;EAAA;IDqFE,kBAAA;EAFF;AACF;AAKA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAHF;AAKE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAHJ;AADE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAHJ;AADE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAHJ;ACxGE;EAAA;ID+GE,eAAA;IACA,mBAAA;EAHF;EAKE;IACE,iBAAA;IACA,uBAAA;EAHJ;EACE;IACE,iBAAA;IACA,uBAAA;EAHJ;EACE;IACE,iBAAA;IACA,uBAAA;EAHJ;AACF;AAOA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,aAAA;EACA,gBAAA;AALF;AC3HE;EAAA;IDmIE,eAAA;IACA,kBAAA;EAJF;AACF;AAOA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AALF;ACvIE;EAAA;ID+IE,mBAAA;EAJF;AACF;AAOA;EACE,eAAA;EACA,cAAA;AALF;AChJE;EAAA;IDwJE,mBAAA;EAJF;AACF;AAOA;ECvFE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDoFA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AADF;ACrKE;EAAA;IDyKE,eAAA;EAAF;AACF;AAGA;EACE,uEAAA;EAAA,+DAAA;EAAA,uDAAA;EAAA,4GAAA;EACA,qBAAA;AADF;AAIA;EACE,+BAAA;UAAA,uBAAA;AAFF;AAKA;EACE,iCAAA;UAAA,yBAAA;AAHF;AAMA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,wCAAA;EACA,6DAAA;UAAA,qDAAA;EACA,6BAAA;UAAA,qBAAA;EACA,kBAAA;AAJF;AAOA;EACE;IACE,UAAA;IACA,iDAAA;YAAA,yCAAA;EALF;EAOA;IACE,UAAA;IACA,0CAAA;YAAA,kCAAA;EALF;AACF;AAHA;EACE;IACE,UAAA;IACA,iDAAA;YAAA,yCAAA;EALF;EAOA;IACE,UAAA;IACA,0CAAA;YAAA,kCAAA;EALF;AACF;AAQA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,oGAAA;EAAA,4FAAA;EAAA,oFAAA;EAAA,kHAAA;EACA,gCAAA;UAAA,wBAAA;AANF;AAQE;EACE,mBAAA;EACA,kCAAA;UAAA,0BAAA;AANJ;AASE;EACE,mBAAA;EACA,4CAAA;UAAA,oCAAA;AAPJ;AAUE;EACE,mCAAA;EACA,cAAA;EACA,gBAAA;AARJ;ACrOE;EAAA;IDiPE,eAAA;IACA,mBAAA;EARF;AACF;AAWA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AATF;ACjPE;EAAA;ID6PE,eAAA;IACA,kBAAA;EARF;AACF;AAWA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;EC7LA,mBAAA;EACA,kBAAA;ED8LA,WAAA;EACA,gBAAA;AARF;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,8BAAA;UAAA,sBAAA;AATJ;AC7QE;EAAA;ID0RE,mBAAA;IACA,eAAA;EATF;AACF;AAYA;EC3NE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDuNA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mCAAA;UAAA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;AALF;AAOE;EACE,mBAAA;EACA,qBAAA;AALJ;AAQE;EACE,+CAAA;UAAA,uCAAA;AANJ;AAcA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAZF;ACnTE;EAAA;IDkUE,aAAA;IACA,cAAA;EAXF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-md;\n\n  .mobile({\n    padding: @spacing-md;\n  });\n}\n\n.modal {\n  position: relative;\n  background: @white;\n  border-radius: @border-radius-lg;\n  max-width: min(100%, 32rem); // 约 512px，长 placeholder / 多语言更易完整显示\n  width: 100%;\n  padding: @spacing-xxl @spacing-lg @spacing-xl;\n  box-shadow: @box-shadow-lg;\n  animation: slideUp 0.3s ease;\n\n  .mobile({\n    max-width: 90%;\n    padding: @spacing-xl @spacing-md;\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem); // 20px\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.title {\n  font-size: @font-size-xxl;\n  font-weight: bold;\n  color: #000;\n  text-align: center;\n  margin: 0 0 @spacing-md 0;\n  line-height: 1.4;\n\n  .mobile({\n    font-size: @font-size-xxl;\n  });\n}\n\n.inputGroup {\n  margin-bottom: @spacing-lg;\n  position: relative;\n\n  .mobile({\n    margin-bottom: @spacing-md;\n  });\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 0; // 允许子项 input 在 flex 内正确收缩，避免 placeholder 被异常裁切\n  border: 1px solid #e0e0e0;\n  border-radius: 1.25rem; // 20px 圆角（默认状态）\n  background: @white;\n  overflow: visible; // 改为 visible，让下拉列表可以显示\n  z-index: 1;\n  transition: border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-height: 3rem; // 48px 统一最小高度\n\n  // 当下拉列表打开时，保持顶部圆角，底部圆角变为0\n  &.inputWrapperOpen {\n    border-radius: 1.25rem 1.25rem 0 0; // 20px 顶部保持圆角，底部变为0\n    border-bottom: 1px solid transparent; // 使用透明边框而不是none，避免闪烁\n  }\n\n  .mobile({\n    min-height: 2.5rem; // 40px\n  });\n}\n\n.input {\n  flex: 1;\n  min-width: 0; // 与 inputWrapper 配合，保证占位符在可用宽度内尽量完整显示\n  width: 100%;\n  padding: @spacing-md;\n  padding-right: @spacing-xs;\n  border: none;\n  outline: none;\n  font-size: @font-size-md;\n  color: @text-color;\n  background: transparent;\n  line-height: 1.5; // 统一行高\n  min-height: auto; // 移除最小高度限制\n\n  &::placeholder {\n    color: #cccccc; // 更浅的灰色\n    font-size: 1rem; \n    line-height: 1.4;\n    letter-spacing: -0.015em;\n  }\n\n  .mobile({\n    padding: @spacing-sm;\n    font-size: @font-size-sm;\n\n    &::placeholder {\n      font-size: 0.8rem; \n      letter-spacing: -0.02em;\n    }\n  });\n}\n\n.characterInput {\n  flex: 1;\n  padding: @spacing-md;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  outline: none; // 移除焦点轮廓\n  min-height: 3rem; // 48px 与输入框保持一致的高度\n\n  .mobile({\n    padding: @spacing-sm;\n    min-height: 2.5rem; // 40px\n  });\n}\n\n.characterName {\n  font-size: @font-size-md; // 与输入框字体大小一致\n  color: @text-color;\n  font-weight: normal; // 移除加粗，与输入框一致\n  width: 100%;\n\n  .mobile({\n    font-size: @font-size-sm; // 移动端与输入框字体大小一致\n  });\n}\n\n.characterPlaceholder {\n  font-size: @font-size-md; // 与输入框字体大小一致\n  color: #cccccc; // 与输入框 placeholder 颜色一致\n\n  .mobile({\n    font-size: @font-size-sm; // 移动端与输入框字体大小一致\n  });\n}\n\n.dropdownButton {\n  .button-reset();\n  padding: @spacing-md;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: @text-color-secondary;\n  flex-shrink: 0;\n\n  .mobile({\n    padding: @spacing-sm;\n  });\n}\n\n.chevron {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-block;\n}\n\n.chevronUp {\n  transform: rotate(0deg);\n}\n\n.chevronDown {\n  transform: rotate(180deg);\n}\n\n.dropdownList {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: @white;\n  border: 1px solid #e0e0e0;\n  border-top: 1px solid transparent; // 顶部边框透明，避免与输入框边框重叠\n  border-radius: 0 0 20px 20px; // 顶部圆角为0，底部圆角与输入框一致（20px），保持整体圆角形状\n  max-height: 12.5rem; // 200px\n  overflow-y: auto;\n  z-index: 10;\n  margin-top: -1px; // 负边距，让下拉列表覆盖输入框的底部边框\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); // 添加阴影增强一体感\n  animation: slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transform-origin: top;\n  overflow-x: hidden;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scaleY(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scaleY(1);\n  }\n}\n\n.dropdownItem {\n  padding: @spacing-md;\n  cursor: pointer;\n  font-size: @font-size-md;\n  color: @text-color;\n  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s ease;\n  transform: translateZ(0); // 启用硬件加速\n\n  &:hover {\n    background: @background-color;\n    transform: translateX(2px); // 轻微右移，增加交互感\n  }\n\n  &:active {\n    background: darken(@background-color, 5%);\n    transform: translateX(0) scale(0.98);\n  }\n\n  &.dropdownItemSelected {\n    background: fade(@primary-color, 10%);\n    color: @primary-color;\n    font-weight: 500;\n  }\n\n  .mobile({\n    padding: @spacing-sm;\n    font-size: @font-size-sm;\n  });\n}\n\n.dropdownItemEmpty {\n  padding: @spacing-md;\n  font-size: @font-size-sm;\n  color: @text-color-secondary;\n  text-align: center;\n\n  .mobile({\n    padding: @spacing-sm;\n    font-size: @font-size-xs;\n  });\n}\n\n.confirmButton {\n  flex: 1;\n  padding: @spacing-md;\n  background: #626cda;\n  border: none;\n  border-radius: 1.25rem; // 20px 圆角\n  color: @white;\n  font-size: @font-size-md;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n  width: 100%;\n  margin-top: @spacing-md;\n\n  &:hover {\n    background: darken(#626cda, 10%);\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-sm;\n    padding: @spacing-sm;\n  });\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  bottom: -60px; // 增加与弹窗的距离\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2.5rem; // 40px\n  height: 2.5rem; // 40px\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: @background-color;\n    border-color: @text-color-secondary;\n  }\n\n  &:active {\n    transform: translateX(-50%) scale(0.95);\n  }\n\n  .mobile({\n    \n  });\n}\n\n.closeIcon {\n  width: 2.5rem; // 40px\n  height: 2.5rem; // 40px\n  object-fit: contain;\n\n  .mobile({\n    width: 2.5rem; // 40px\n    height: 2.5rem; // 40px\n  });\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LeaS1fFr`,
	"modal": `J2HP87iK`,
	"slideUp": `LTjc1z3e`,
	"title": `HvSwzAXT`,
	"inputGroup": `fZaUwFkV`,
	"inputWrapper": `_969EMhxi`,
	"inputWrapperOpen": `RcnOIgJC`,
	"input": `bKdnsQEy`,
	"characterInput": `Ymu4vWVF`,
	"characterName": `nj9mfuGx`,
	"characterPlaceholder": `zwv60tv4`,
	"dropdownButton": `TqWA51oL`,
	"chevron": `VgvIGa05`,
	"chevronUp": `ZV5EWaOt`,
	"chevronDown": `zohX71bj`,
	"dropdownList": `uKhqf4zw`,
	"slideDown": `hPWD94DU`,
	"dropdownItem": `PkycylE_`,
	"dropdownItemSelected": `IaZIvCvG`,
	"dropdownItemEmpty": `OvuUhSxr`,
	"confirmButton": `Ipquc5gU`,
	"closeButton": `OvPYSVbM`,
	"closeIcon": `L4jaH609`
};
export default ___CSS_LOADER_EXPORT___;
